import { Progress, SignalDot } from '@indipia/ui-core'
import type { ListProgressStat, ListSummary } from '../../types/scheduleList.types'

// 요약줄(D-02) — 진행 막대 3개(라벨 + a / b + 막대) + 우측 조치 필요·대기·총 개수. 필터와 무관, 현장 전체 기준(B-07).

interface ProgressItemProps {
  label: string
  stat: ListProgressStat
}

function ProgressItem({ label, stat }: ProgressItemProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-02)', minWidth: 'var(--num-96)' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 'var(--spacing-03)' }}>
        <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)', whiteSpace: 'nowrap' }}>{label}</span>
        <span style={{ fontSize: 'var(--type-body-sm-size)', fontWeight: 700, color: 'var(--shell-on-surface)', whiteSpace: 'nowrap' }}>
          {stat.done} / {stat.total}
        </span>
      </div>
      <Progress value={stat.percent} aria-label={`${label} ${stat.done} / ${stat.total}`} />
    </div>
  )
}

interface CountItemProps {
  color: 'RED' | 'YELLOW'
  label: string
  count: number
}

function CountItem({ color, label, count }: CountItemProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-02)', whiteSpace: 'nowrap', fontSize: 'var(--type-body-sm-size)', color: 'var(--shell-on-surface)' }}>
      <SignalDot color={color} size={8} label={label} />
      {label} <strong>{count}</strong>
    </span>
  )
}

export interface ScheduleListSummaryBarProps {
  summary: ListSummary
}

export function ScheduleListSummaryBar({ summary }: ScheduleListSummaryBarProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--spacing-05)', padding: 'var(--spacing-04) var(--spacing-05)', background: 'var(--shell-surface)', borderBottom: 'var(--border-width-hairline) solid var(--shell-border)' }}>
      <ProgressItem label="반장 일정 확정" stat={summary.foreman} />
      <ProgressItem label="발주 · 입고 완료" stat={summary.order} />
      <ProgressItem label="작업 검수완료" stat={summary.work} />
      <div style={{ flex: 1 }} />
      <CountItem color="RED" label="조치 필요" count={summary.redCount} />
      <CountItem color="YELLOW" label="대기" count={summary.yellowCount} />
      <span style={{ fontSize: 'var(--type-body-sm-size)', color: 'var(--shell-on-surface-2)', whiteSpace: 'nowrap' }}>
        총 {summary.taskCount}개 공종 · 마일스톤 {summary.milestoneCount}개
      </span>
    </div>
  )
}
